import { AxiosPromise } from 'axios';
import digitalDataAssignment from '../../../../../../common/utilities/digitalDataAssignment';
import {
  DataLayerEvent,
  DataLayerFormName,
  DataLayerFormStage,
  SpeckPackListType,
} from '../../../../../../common/utilities/customDatalayerInterface';
import { IModel } from '../../../model/listResponse';
import dataLayerToggleVerification from '../../../../../../common/utilities/dataLayerToggleVerification';
import IProductVariantList from '../../../model/IProductVariantList';
import IDimensions from '../../../model/IDimensions';
import { customerStorage } from '../../../../../../common/service/customerStorage';

const VariantDataLayerRest: (
  promiseList: AxiosPromise<IProductVariantList> | null,
  dimension: IDimensions,
) => Promise<void> = async (promiseList: AxiosPromise<IProductVariantList> | null, dimension: IDimensions) => {
  try {
    const isDataLayer = dataLayerToggleVerification(dimension);

    if (isDataLayer) {
      const specPacks: SpeckPackListType[] = [];
      const customerStorageValue = customerStorage.getCustomerData(dimension);

      if (promiseList !== null) {
        const variantDataList: IModel[] = await promiseList.then(promiseListResponse =>
          Object.values(Object.assign({}, ...Object.values(promiseListResponse.data.items))),
        );

        variantDataList?.forEach(item => {
          const { prices } = item;
          specPacks.push({
            nameplate: {
              modelYear: item?.modelYear?.toString(),
            },
            addOnFeatures: [],
            standardFeatures: item?.keyFeatures?.map(feature => {
              return {
                name: feature?.description,
                id: feature?.order,
              };
            }),
            prices: [
              {
                carPrice: {
                  originalPrice: prices[0]?.originalPrice,
                  finalPrice: prices[0]?.distributionPrice,
                },
                totalPrice: prices[0]?.distributionPrice,
                currency: prices[0]?.currency,
              },
            ],
          });
        });
      }

      digitalDataAssignment({
        event: DataLayerEvent.FORM_NAVIGATE,
        form: {
          name: DataLayerFormName.CONFIGURATOR,
          stage: DataLayerFormStage.VARIANT_CONFIGURATOR,
          details: {
            configurator: {
              specPacks: specPacks,
              selectedSpec: [],
            },
          },
        },
        user: {
          postCode: customerStorageValue?.postcode,
        },
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('DataLayer error', err);
  }
};

export default VariantDataLayerRest;
